import PasswordInput from 'components/Inputs/PasswordInput'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import passwordValidator from 'validators/passwordValidator'
import PasswordStrengthBar from 'components/PasswordStrengthBar'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Form,
  Row,
  SubTitle,
  FormField,
  WarningText
} from '../styles'

export default function PasswordForm ({
  businessData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  return (
    <Formik
      validationSchema={passwordValidator}
      initialValues={{
        'password': businessData.password,
        'password_confirmation': businessData.password_confirmation
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form onKeyDown={submitOnEnter(handleSubmit)} autoComplete='off' style={{ width: 400 }}>
          <SubTitle>Segurança</SubTitle>
          <Row>
            <FormField>
              <PasswordInput
                placeholder='Senha'
                value={values.password}
                onChange={handleChange ('password')}
                onBlur={handleBlur ('password')}
              />
              {touched.password && errors.password && (
                <WarningText>{errors.password}</WarningText>
              )}
              <PasswordStrengthBar password={values.password}/>
            </FormField>
          </Row>
          <Row>
            <FormField>
              <PasswordInput
                placeholder='Confirmar senha'
                value={values.password_confirmation}
                onChange={handleChange ('password_confirmation')}
                onBlur={handleBlur ('password_confirmation')}
              />
              {touched.password_confirmation && errors.password_confirmation && (
                <WarningText>{errors.password_confirmation}</WarningText>
              )}
            </FormField>
          </Row>
          <MainButton
            leftIcon={<MdNavigateNext size={30}/>}
            aria-label='Próximo'
            onClick={handleSubmit}
            width={60}
          />
        </Form>
      )}
    </Formik>
  )
}
